<script>
  /* global agGrid */
  import GRID_LOCALE_CS from '../../js/gridLocaleCs.js';
  import GRID_LOCALE_EN from '../../js/gridLocaleEn.js';
  import { onMount } from 'svelte';

  export let value;
  export let lang = undefined;
  export let mode = undefined;

  let gameStatisticsPitchersElement;

  let gridOptions;

  function getOptions () {
    return {
      theme: 'legacy',
      defaultColDef: {
        cellDataType: 'number',
        type: 'numericColumn',
        width: 56.25,
        sortable: false,
        filter: false,
      },
      columnDefs: [
        {
          headerName: lang !== 'en' ? 'Nadhazovač' : 'Pitcher',
          // eslint-disable-next-line no-magic-numbers
          openByDefault: window.innerWidth > 1200 || (window.innerWidth <= 1000 && window.innerWidth > 800),
          children: [
            {
              field: 'spot',
              headerName: '##',
              width: 45,
              cellDataType: 'number',
              type: 'numericColumn',
              pinned: true,
            },
            {
              field: 'lastName',
              headerName: lang !== 'en' ? 'Příjmení' : 'Last name',
              width: 135,
              cellDataType: 'text',
              type: [],
              pinned: true,
              cellStyle: { fontWeight: 'bold' },
              valueFormatter: params => {
                if (params.data.pitching.w) return `${params.value} (W)`;
                if (params.data.pitching.l) return `${params.value} (L)`;
                if (params.data.pitching.s) return `${params.value} (S)`;
                return params.value;
              },
            },
            {
              field: 'firstName',
              headerName: lang !== 'en' ? 'Jméno' : 'First name',
              width: 135,
              cellDataType: 'text',
              type: [],
              pinned: true,
              columnGroupShow: 'open',
            },
            {
              field: 'positions',
              headerName: lang !== 'en' ? 'Poz.' : 'Pos.',
              headerTooltip: lang !== 'en' ? 'Pozice' : 'Positions',
              width: 67.5,
              cellDataType: 'text',
              type: [],
              pinned: true,
              columnGroupShow: 'open',
              valueFormatter: params => params.value.join(' / '),
            },
          ],
        },
        {
          field: 'pitching.era',
          headerName: 'ERA',
          headerTooltip: 'Earned run average',
          width: 67.5,
          valueFormatter: params => params.value.toFixed(3),
        },
        {
          field: 'pitching.ip',
          headerName: 'IP',
          headerTooltip: 'Innings pitched',
          cellStyle: { fontWeight: 'bold' },
          valueFormatter: params => params.value.toFixed(1),
        },
        {
          field: 'pitching.bf',
          headerName: 'BF',
          headerTooltip: 'Batters faced',
          cellStyle: { fontWeight: 'bold' },
        },
        {
          field: 'pitching.ab',
          headerName: 'AB',
          headerTooltip: 'At bat',
          cellStyle: { fontWeight: 'bold' },
        },
        {
          field: 'pitching.r',
          headerName: 'R',
          headerTooltip: 'Run',
          cellStyle: { fontWeight: 'bold' },
        },
        {
          field: 'pitching.er',
          headerName: 'ER',
          headerTooltip: 'Earned run',
          cellStyle: { fontWeight: 'bold' },
        },
        {
          field: 'pitching.h',
          headerName: 'H',
          headerTooltip: 'Hit',
          cellStyle: { fontWeight: 'bold' },
        },
        {
          field: 'pitching.2b',
          headerName: '2B',
          headerTooltip: 'Double',
        },
        {
          field: 'pitching.3b',
          headerName: '3B',
          headerTooltip: 'Triple',
        },
        {
          field: 'pitching.hr',
          headerName: 'HR',
          headerTooltip: 'Home run',
        },
        {
          field: 'pitching.sh',
          headerName: 'SH',
          headerTooltip: 'Sacrifice bunt',
        },
        {
          field: 'pitching.sf',
          headerName: 'SF',
          headerTooltip: 'Sacrifice fly',
        },
        {
          field: 'pitching.bb',
          headerName: 'BB',
          headerTooltip: 'Walk',
          cellStyle: { fontWeight: 'bold' },
        },
        {
          field: 'pitching.hp',
          headerName: 'HP',
          headerTooltip: 'Hit by pitch',
        },
        {
          field: 'pitching.k',
          headerName: 'K',
          headerTooltip: 'Strikeout',
          cellStyle: { fontWeight: 'bold' },
        },
        {
          field: 'pitching.wp',
          headerName: 'WP',
          headerTooltip: 'Wild pitch',
        },
        {
          field: 'pitching.bk',
          headerName: 'BK',
          headerTooltip: 'Balk',
        },
        {
          flex: 1,
          filter: false,
          sortable: false,
          suppressMovable: true,
        },
      ],
      animateRows: true,
      tooltipShowDelay: 500,
      domLayout: 'autoHeight',
      rowData: value,
      localeText: lang !== 'en' ? GRID_LOCALE_CS : GRID_LOCALE_EN,
    };
  }

  onMount(() => {
    gridOptions = getOptions();

    gridOptions.api = agGrid.createGrid(gameStatisticsPitchersElement, gridOptions);
  });

  $: if (gridOptions && lang) {
    gridOptions.api.destroy();
    gridOptions = getOptions();

    gridOptions.api = agGrid.createGrid(gameStatisticsPitchersElement, gridOptions);
  }
</script>

<div class='game-statistics-pitchers ag-theme-balham' bind:this={gameStatisticsPitchersElement}
  class:ag-theme-balham-dark={mode !== 'light'}/>

<style>
  .game-statistics-pitchers {
    width: 100%;
    height: 100%;
  }

  :global(.ag-root-wrapper) {
    border-radius: var(--radius-lg);
  }
</style>
